import { IConstraintPrematureWellShutdownInteractingTargetFormation } from '../../interfaces/iconstraint-premature-well-shutdown-interacting-target-formation';
import { ConstraintPrematureWellShutdownDetail } from '../constraint-premature-well-shutdown-detail';
import { TargetFormation } from '../target-formation';

export class ConstraintPrematureWellShutdownInteractingTargetFormationBase {
  ConstraintPrematureWellShutdownInteractingTargetFormationId: number;
  ConstraintPrematureWellShutdownDetailId: number;
  InteractingTargetFormationId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ConstraintPrematureWellShutdownDetail?: ConstraintPrematureWellShutdownDetail;
  TargetFormation?: TargetFormation;

  constructor(item?: IConstraintPrematureWellShutdownInteractingTargetFormation) {
    if (item) {

      this.ConstraintPrematureWellShutdownInteractingTargetFormationId = item.ConstraintPrematureWellShutdownInteractingTargetFormationId;
      this.ConstraintPrematureWellShutdownDetailId = item.ConstraintPrematureWellShutdownDetailId;
      this.InteractingTargetFormationId = item.InteractingTargetFormationId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ConstraintPrematureWellShutdownDetail = new ConstraintPrematureWellShutdownDetail(item.ConstraintPrematureWellShutdownDetail);
      this.TargetFormation = new TargetFormation(item.TargetFormation);
    }
  }
}